import { Text } from '../components';
import { get } from '@jds/utils';

export const convertTextToComponent = <P,>(children?: string | P) => {
  if (typeof children === 'string' && children.length) {
    return <Text text={children} />;
  }
  return children || null;
};

export const resolveComponent = <T,>(Component: React.FC<T>) => {
  if (typeof Component === 'undefined') return null;
  return Component;
};

export const resolvePropObjectKeys = <P extends object, Q>(
  prop: string | P | undefined,
  objPath: string,
  defValue?: Q
): string | Q | undefined => {
  if (!prop) {
    return undefined;
  }

  if (typeof prop === 'string') {
    return prop;
  }
  return get(prop, objPath, defValue);
};
